import React from "react";

const STATS = [
  { num: "6", label: "Universities" },
  { num: "5+", label: "Disciplines" },
  { num: "∞", label: "Reflection Threads" },
];

const ProfEMultiContext: React.FC = () => (
  <section className="pe-section pe-section--cyan pe-multi">
    <img
      className="pe-multi__mascot-bg"
      src="/images/prof-e/pose-8-reading-open.png"
      alt=""
      aria-hidden="true"
    />
    <div className="pe-container pe-multi__heading">
      <h2>A Growing Stem Cell Across Multiple Contexts</h2>
      <p className="pe-multi__lede">
        Already used in entrepreneurship, medical education, business school, social
        innovation, and wellness programs. Prof. E adapts like a stem cell &mdash; reshaping
        itself to fit each learning environment, learning and growing as students use it.
      </p>
      <div className="pe-multi__stats">
        {STATS.map((s) => (
          <div className="pe-multi__stat" key={s.label}>
            <div className="pe-multi__stat-num">{s.num}</div>
            <div className="pe-multi__stat-label">{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ProfEMultiContext;
